<template>
    <MultiSelect 
        :id="id" 
        v-model="selectedValue" 
        :options="affiliateSystemOptions" 
        optionLabel="label"
        optionValue="value" 
        :placeholder="placeholder" 
        :maxSelectedLabels="maxSelectedLabels" 
        :class="classes"
        :multiple="multiple" 
        display="chip"
        @update:modelValue="updateValue"
    >
        <!-- Selected Value Template (Chips) -->
        <template #value="slotProps">
            <div v-if="slotProps.value.length > 0">
                <template v-if="slotProps.value.length <= maxSelectedLabels">
                    <div v-for="option in slotProps.value" :key="option" class="inline-flex items-center mr-2">
                        <span>{{ option }}</span>
                    </div>
                </template>
                <span v-else>
                    {{ slotProps.value.length }} systems selected
                </span>
            </div>
            <span v-else>{{ placeholder }}</span>
        </template>
        
        <!-- Option Template -->
        <template #option="slotProps">
            <div class="flex items-center">
                <div>{{ slotProps.option.label }}</div>
            </div>
        </template>

        <!-- Selected Items Template -->
        <template #chip="slotProps">
            <div class="flex items-center">
                <span>{{ slotProps.value }}</span>
            </div>
        </template>
    </MultiSelect>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import MultiSelect from 'primevue/multiselect';

const props = defineProps({
    modelValue: {
        type: Array,
        default: () => []
    },
    affiliateSystemOptions: {
        type: Array,
        required: true
    },
    id: {
        type: String,
        default: 'affiliate-system-selector'
    },
    placeholder: {
        type: String,
        default: 'Affiliate Systems'
    },
    maxSelectedLabels: {
        type: Number,
        default: 2
    },
    classes: {
        type: String,
        default: 'w-full sm:w-[20%]'
    },
    multiple: {
        type: Boolean,
        default: true
    }
});

const emit = defineEmits(['update:modelValue']);

const selectedValue = ref(props.modelValue);

// Watch for external changes to modelValue
watch(() => props.modelValue, (newValue) => {
    selectedValue.value = newValue;
});

// Update parent when local value changes
const updateValue = (value) => {
    emit('update:modelValue', value);
};
</script>
